/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer3_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_viewer" | "IgnoredTombstoneOrHideContainer_viewer" | "LocalReplyListContainer_viewer">;
    readonly " $refType": "ReplyListContainer3_viewer";
};
export type ReplyListContainer3_viewer$data = ReplyListContainer3_viewer;
export type ReplyListContainer3_viewer$key = {
    readonly " $data"?: ReplyListContainer3_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer3_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer3_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LocalReplyListContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '6494d6c0ffef8c338de4fd41e8edb7fa';
export default node;
